import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { ContentTile } from '@as/cotopaxi';
import { SlideType, } from '@as-react/common-types';
import { isNullOrUndefined } from '@as-react/common-utils';
import Image from '../components/image/Image';
import VideoPlayer from '../components/video-player/VideoPlayer';
import { getContentTileSrcSet } from '../util/ImageUtil';
import CategoryTileContainer from './CategoryTileContainer';
import SingleProductTileContainer from './SingleProductTileContainer';
import TeaserContainer from './TeaserContainer';
export const SlideRenderer = ({ slide, cdnSettings, imageCdnPrefix, contentTileTranslations, slidesToShowDesktop, }) => {
    const { type } = slide, slideProps = __rest(slide, ["type"]);
    switch (type) {
        case SlideType.IMAGE:
            return _jsx(Image, Object.assign({}, slideProps));
        case SlideType.CATEGORY_TILE:
            return _jsx(CategoryTileContainer, Object.assign({}, slideProps));
        case SlideType.TEASER:
            return _jsx(TeaserContainer, Object.assign({}, slideProps, { mainCdnSettings: cdnSettings }));
        case SlideType.SINGLE_PRODUCT_TILE:
            return (_jsx("div", { style: { height: 'auto' }, children: _jsx(SingleProductTileContainer, Object.assign({}, slideProps, { withoutSpacing: true, shouldInitProduct: false, adjustTileDescriptionHeight: slideProps.tileFormat === 'simple' })) }));
        case SlideType.CONTENT_TILE: {
            const _a = slideProps, { image } = _a, contentTileProps = __rest(_a, ["image"]);
            return (_jsx(ContentTile, Object.assign({}, contentTileProps, { translations: contentTileTranslations, image: isNullOrUndefined(image)
                    ? { src: '' }
                    : {
                        src: `${imageCdnPrefix}${image.imagePath}`,
                        srcset: getContentTileSrcSet(image, imageCdnPrefix, slidesToShowDesktop),
                        isPicture: true,
                        lazy: true,
                    }, withoutSpacing: true })));
        }
        case SlideType.VIDEO:
            return _jsx(VideoPlayer, Object.assign({}, slideProps));
        default:
            return null;
    }
};
